import { render } from "./SyncResidents.vue?vue&type=template&id=3d589168"
import script from "./SyncResidents.vue?vue&type=script&lang=js"
export * from "./SyncResidents.vue?vue&type=script&lang=js"

import "./SyncResidents.vue?vue&type=style&index=0&id=3d589168&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__